import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoEmail from 'assets/img/logo-email.svg';
import { PATH_MAGIC_LINK } from 'routes/route.path';

export default function LoginWithEmail({ loading }) {
  const navigate = useNavigate();

  const handleNavigateToEmailLink = () => {
    navigate(PATH_MAGIC_LINK);
  };

  return (
    <button
      onClick={handleNavigateToEmailLink}
      id="login-email"
      disabled={loading}
      type="button"
      className="d-flex align-items-center"
    >
      <div className="d-flex align-items-center gap-3">
        <img className="icon" src={logoEmail} alt="Logo-email" />
        <span className="button-text">Sign in with Email</span>
      </div>
    </button>
  );
}
